/* Sends website forms to HubSpot (Forms API v3, unauthenticated endpoint).
   Portal and form IDs live in window.LYS_HUBSPOT, set in snippets/lys-v4-scripts.liquid. */
try {
(function(){
  var cfg = window.LYS_HUBSPOT || {};

  // HubSpot tracking cookie: links the submission to the visitor's page history (only set if the tracking script runs)
  function hutk(){
    var m = document.cookie.match(/(?:^|;\s*)hubspotutk=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // preview-only diagnostic box (never shown on the published theme)
  function isPreview(){
    try {
      var S = window.Shopify || {};
      return !!(S.designMode || (S.theme && S.theme.role && S.theme.role !== 'main') ||
        /shopifypreview\.com$/.test(location.hostname) || /preview_theme_id=/.test(location.search));
    } catch (e) { return false; }
  }
  function debug(text){
    console.info('lys-v4 hubspot: ' + text);
    if (!isPreview()) return;
    var box = document.getElementById('lysHsDebug');
    if (!box){
      box = document.createElement('div'); box.id = 'lysHsDebug';
      box.setAttribute('style', 'position:fixed;left:12px;bottom:12px;z-index:99999;max-width:min(92vw,520px);background:#fff8d6;color:#222;border:1px solid #c9a800;border-radius:6px;padding:10px 12px;font:12px/1.45 monospace;white-space:pre-wrap;box-shadow:0 4px 16px rgba(0,0,0,.15);cursor:pointer');
      box.addEventListener('click', function(){ box.remove(); });
      document.body.appendChild(box);
    }
    box.textContent = 'HubSpot check (preview only, tap to close)\n' + text;
  }

  // fields: [{name, value, objectTypeId?}] ; empty values are dropped; objectTypeId defaults to contact (0-1)
  function submit(formKey, fields){
    var guid = cfg.forms && cfg.forms[formKey];
    if (!cfg.portalId || !guid) { debug(formKey + ': not configured, nothing sent'); }
    if (!cfg.portalId || !guid) return Promise.resolve({ ok: false, errors: [{ message: 'HubSpot form not configured: ' + formKey }] });
    var body = {
      fields: fields.filter(function(f){ return f.value !== undefined && f.value !== null && String(f.value).trim() !== ''; })
                    .map(function(f){ return { objectTypeId: f.objectTypeId || '0-1', name: f.name, value: String(f.value).trim() }; }),
      context: { pageUri: location.href, pageName: document.title }
    };
    var t = hutk(); if (t) body.context.hutk = t;
    debug(formKey + ': sending ' + body.fields.length + ' fields…');
    var url = 'https://api.hsforms.com/submissions/v3/integration/submit/' + cfg.portalId + '/' + guid;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().catch(function(){ return {}; }).then(function(j){
        if (!r.ok) console.error('lys-v4 hubspot ' + formKey, r.status, j);
        debug(formKey + ': HTTP ' + r.status + (r.ok ? ' (accepted by HubSpot)' : ' (rejected)\n' + JSON.stringify(j.errors || j.message || j, null, 1).slice(0, 900)));
        return { ok: r.ok, errors: j.errors || [] };
      }); })
      .catch(function(e){ console.error('lys-v4 hubspot ' + formKey, e); debug(formKey + ': request failed before reaching HubSpot\n' + String(e)); return { ok: false, errors: [{ message: String(e) }] }; });
  }

  window.LYS_HS = { submit: submit, debug: debug };
})();
} catch (e) { console.error("lys-v4 hubspot", e); }
